module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"app-name":"AI Server","message":{"hello":"hello world"}},"zh-tw":{"app-name":"AI 服務生","message":{"hello":"chinese hello"}}}')
  delete Component.options._Ctor
}
